export const booleanOptions = Object.values(['No', 'Yes']).map((option) => ({
  value: option === 'Yes',
  label: option,
}));
